import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.BACKEND_URL + "/auth";
  private baseUrl = environment.BACKEND_URL;
  constructor(private http: HttpClient , private storageService: StorageService) { }

  login(userData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/login`, userData);
  }

  register(userData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/register`, userData);
  }

  registerDesignPartner(partnerData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/design-partner`, partnerData);
  }

  loginDesignPartner(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/design-partner/login`, credentials);
  }

  verifyOtp(otpData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify-otp`, otpData);
  }

  testEmail(email: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/test-email`, { email });
  }

  forgotPassword(email: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/forgot-password`, { email });
  }

  setPassword(userData: any) {
    return this.http.post(`${this.apiUrl}/set-password`, userData);
  }

  googleSignin(userData: any): Observable<any>{
    return this.http.post(`${this.apiUrl}/google`, userData);
  }

  private isBrowser(): boolean {
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  }

  saveToken(token: string): void {
    localStorage.setItem('authToken', token);
  }

  removeToken(): void {
    localStorage.removeItem('authToken');
  }

  getToken(): string | null{
    const token = localStorage.getItem('authToken'); 
    return token; 
  }
  getUser(){
    const userStr = localStorage.getItem('currentUser'); 
    if(userStr == null) return null;
    return JSON.parse(userStr); 
  }

  setAuthData(token: string, user: any): void {
    console.log("auth.service.ts [2234f8] storing user: ", user);
    if (this.isBrowser()) {
      localStorage.setItem('authToken', token);
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  }
  setUser( user: any): void {
    if (this.isBrowser()) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  }

  setSubscription(subscriptions: any): void{
    if(this.isBrowser()){
      localStorage.setItem('subscriptions', JSON.stringify(subscriptions)); 
    }
  }

  getSubscription(): boolean {
    if (this.isBrowser()) {
      const subscriptions = localStorage.getItem('subscription');
  
      if (subscriptions) {
        try {
          const parsedSubscriptions = JSON.parse(subscriptions);
          console.log("Parsed from local storage", parsedSubscriptions); 
          if (parsedSubscriptions?.currentPeriodEnd) {
            const currentPeriodEnd = new Date(parsedSubscriptions.currentPeriodEnd);
            const now = new Date();
  
            if (currentPeriodEnd.getTime() > now.getTime()) {
              console.log(currentPeriodEnd.getTime(), now.getTime());
              return true; 
            }
          }
        } catch (error) {
          console.error("Error parsing subscriptions from localStorage: ", error);
        }
      }
    }

    return false;
  }
  getSubscriptionPlan() {
    if (this.isBrowser()) {
      const subscriptions = localStorage.getItem('user-subscription');
  
      if (subscriptions) {
        try {
          const parsedSubscriptions = JSON.parse(subscriptions);
          console.log("Parsed from local storage", parsedSubscriptions); 
          if (parsedSubscriptions?.currentPeriodEnd) {
              const currentPeriodEnd = new Date(
                parsedSubscriptions.currentPeriodEnd
              );
              const now = new Date();

              if (currentPeriodEnd.getTime() > now.getTime()) {
                console.log(currentPeriodEnd.getTime(), now.getTime());
                return parsedSubscriptions.plan ?? parsedSubscriptions.planId;
              }
          }
        } catch (error) {
          console.error("Error parsing subscriptions from localStorage: ", error);
        }
      }
    }

    return null;
  }

  clearSubscription(): void{
    if(this.isBrowser()){
      localStorage.removeItem('subscriptions');
     this.storageService.deleteUserSubscription(); // Clear subscription from StorageService
    }
  }

  clearAuthData(): void {
    if (this.isBrowser()) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('currentUser');
    }
  }

  isLoggedIn(): boolean {
    if (this.isBrowser()) {
      const token = localStorage.getItem('authToken');
      return !!token;
    }
    return false;
  }

 verifyResetToken(token: string) {
  return this.http.post(`${this.baseUrl}/auth/verify-reset-link`, { reset_id: token });
}

resetPassword(reset_id: string, user_id: string, password: string) {
  return this.http.post(`${this.baseUrl}/auth/password-reset-via-link`, {
    reset_id,
    user_id,
    password
  });
}





}
